import { render, staticRenderFns } from "./CategoryRankChart.vue?vue&type=template&id=01cd728a&scoped=true"
import script from "./CategoryRankChart.vue?vue&type=script&lang=js"
export * from "./CategoryRankChart.vue?vue&type=script&lang=js"
import style0 from "./CategoryRankChart.vue?vue&type=style&index=0&id=01cd728a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd728a",
  null
  
)

export default component.exports